<div class="glass" *ngIf="glass"></div>
<div class="bubble-outline" *ngIf="glass"></div>
<div class="model-wrapper" #wrapper [style.opacity]="glassOnly ? 0 : 1"></div>
